import { OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DashboardService } from '../../dashboard';
import { ErrorHandlerService } from '../../services';
import { LoginService } from '../../login';
var ProfileComponent = /** @class */ (function () {
    function ProfileComponent(userService, dashboardService, errorHandlerService, router, route) {
        this.userService = userService;
        this.dashboardService = dashboardService;
        this.errorHandlerService = errorHandlerService;
        this.router = router;
        this.route = route;
        this.displaySpinner = true;
        this.myRating = [];
        this.allcir = [];
        this.coursename = '';
        this.viewProfile = {};
        this.user = {};
        this.sub = {};
        this.query = {};
        this.invitereq = { requestTo: {}, requestFrom: {} };
        this.userRcmd = [];
        this.userReqCourse = { requestTo: {}, requestFrom: {}, skillSet: {} };
        this.reqRcmd = { requestTo: {}, requestFrom: {} };
        this.rating = { responseTo: {}, responseFrom: {}, rating: {} };
        this.getSkills = [];
        this.usergetSkills = [];
        this.allskills = [];
        this.coursebyMe = [];
        this.userprofiledata = {};
        this.skillArr = {};
        this.sendMsg = false;
        this.msgData = {};
        this.ts = new Date();
        this.msgTitle = "";
        this.msgContent = "";
        this.popUp = false;
        this.showSpinner = false;
        this.showOnlyOverlay = false;
        this.showErrorModalDialog = false;
        this.showErrorMessages = [""];
        this.showErrorMessageTitle = "Error!";
        this.showErrorMessageWidthInPercentage = "20%";
        this.subscriptions = [];
        this.isSessionExpired = false;
        this.results = [];
        this.usertyperesults = [];
        this.cityresults = [];
        this.eduInstresults = [];
        this.selectedCountryId = -1;
        this.selectedStateId = -1;
        this.stateIdNameMap = {};
        //cityIdNameMap: any = {};
        this.time_zone = "";
        this.loading = false;
        this.isValidationError = true;
        this.isCorporateUser = true;
        this.openStep2Popup = false;
        this.countryId = null;
        this.city = "";
    }
    ProfileComponent.prototype.editDisplay = function (edit) {
        if (edit) {
            return "block";
        }
        else {
            return "none";
        }
    };
    ProfileComponent.prototype.sendMessage = function () {
        var _this = this;
        this.msgData.usersInTo = [this.query];
        var s1 = this.dashboardService.inboxSendMsg(this.msgData).subscribe(function (data) {
            _this.sendMsg = false;
            console.log(data);
            _this.msgTitle = "Success";
            _this.msgContent = "Message Sent!!";
            _this.popUp = true;
        }, function (error) {
            _this.handleError(error);
            _this.sendMsg = false;
        });
        this.subscriptions.push(s1);
    };
    ProfileComponent.prototype.sendCourseReq = function () {
        var _this = this;
        this.userReqCourse.userRequestType = 'CREATE_COURSE_REQUEST';
        console.log(this.userReqCourse);
        var s2 = this.dashboardService.courseReq(this.userReqCourse).subscribe(function (data) { _this.skillpopup = false; }, function (error) {
            _this.handleError(error);
            _this.skillpopup = false;
        });
        this.subscriptions.push(s2);
    };
    ProfileComponent.prototype.rcmdReq = function () {
        var _this = this;
        this.reqRcmd.userRequestType = 'RECOMMENDATION_REQUEST';
        console.log(this.reqRcmd);
        var s3 = this.dashboardService.rcmdRequest(this.reqRcmd).subscribe(function (data) {
            _this.reqforrcmd = false;
            _this.msgTitle = "Success";
            _this.msgContent = "Request Sent!!";
            _this.popUp = true;
        }, function (error) {
            _this.handleError(error);
            _this.reqforrcmd = false;
        });
        this.subscriptions.push(s3);
    };
    ProfileComponent.prototype.ratingUser = function () {
        var _this = this;
        this.rating.userResponseType = 'RATING_RESPONSE';
        console.log(this.rating);
        var s4 = this.dashboardService.rating(this.rating).subscribe(function (data) { _this.ratethis = false; }, function (error) {
            _this.handleError(error);
            _this.ratethis = false;
        });
        this.subscriptions.push(s4);
    };
    ProfileComponent.prototype.sendInvite = function () {
        var _this = this;
        this.invitereq.userRequestText = "Invitation Request sent by User Id " + this.user.userDetailsId + " to User Id " + this.query + ". Sent by REST Service.";
        this.invitereq.userRequestType = 'INVITATION_REQUEST';
        console.log(this.invitereq);
        var s5 = this.dashboardService.sendInvitationReq(this.invitereq).subscribe(function (data) {
            _this.getUser(_this.query);
        }, function (error) {
            _this.handleError(error);
        });
        this.subscriptions.push(s5);
    };
    ProfileComponent.prototype.acceptInvite = function () {
        var _this = this;
        var s6 = this.dashboardService.connAccept(this.userprofiledata.invitationRequestId).subscribe(function (data) { _this.getUser(_this.query); }, function (error) {
            _this.handleError(error);
        });
        this.subscriptions.push(s6);
    };
    ProfileComponent.prototype.ngOnInit = function () {
        var _this = this;
        console.log('inside ngOnInit()');
        this.showSpinner = true;
        var s7 = this.dashboardService.userSummary1().subscribe(function (data) {
            _this.user = data;
            if (data.countryId != null)
                _this.countryId = data.countryId;
            if (data.city != null)
                _this.city = data.city;
            _this.invitereq.requestFrom.userDetailsId = data.userDetailsId;
            _this.reqRcmd.requestFrom.userDetailsId = data.userDetailsId;
            _this.rating.responseFrom.userDetailsId = data.userDetailsId;
        }, function (error) {
            _this.handleError(error);
        });
        this.subscriptions.push(s7);
        var s8 = this.sub = this.route.queryParams.subscribe(function (params) {
            _this.query = params['user'] || 0;
            _this.invitereq.requestTo.userDetailsId = _this.query;
            // this.sub = this.route.params.subscribe(params => {
            // 	console.log('test');
            // 	this.query = +params['id'] || 0;; // (+) converts string 'id' to a number
            // // In a real app: dispatch action to load the details here.
            // });
            if (_this.query == '0') {
                _this.anotheruser = false;
                console.log('no query string');
                _this.dashboardService.viewProfile().subscribe(function (res) {
                    _this.viewProfile = res;
                    console.log(res);
                    _this.allcir = res.coursesIRecommend;
                    _this.myRating = Array(res.noOfRatingStars);
                    console.log('myRating');
                    console.log(_this.myRating);
                    _this.showSpinner = false;
                }, function (error) {
                    _this.handleError(error);
                });
                _this.dashboardService.viewcourseByMe().subscribe(function (res) { _this.coursebyMe = res; console.log(res); }, function (error) {
                    _this.handleError(error);
                });
                _this.dashboardService.getSkills().subscribe(function (data) {
                    _this.getSkills = data;
                    _this.getSkills.forEach(function (val, ind, arr) {
                        var skillSetName = (val.userSkillSetName != null && val.userSkillSetName != undefined) ? val.userSkillSetName : val.skillSet.name;
                        _this.allskills.push(skillSetName);
                    });
                }, function (error) {
                    _this.handleError(error);
                });
                // this.dashboardService.getCiRcmd().subscribe(
                //   data => {
                //     this.allcir = data;
                //   },
                //   error => {
                //     console.log(error);
                //   }
                // );
                document.documentElement.scrollTop = 0;
            }
            else {
                _this.anotheruser = true;
                _this.getUser(_this.query);
                document.documentElement.scrollTop = 0;
            }
        });
        this.subscriptions.push(s8);
    };
    ProfileComponent.prototype.addhttp = function (url) {
        if (!/^(?:f|ht)tps?\:\/\//.test(url)) {
            url = "http://" + url;
        }
        return url;
    };
    ProfileComponent.prototype.getUser = function (id) {
        var _this = this;
        var s9 = this.dashboardService.profileVisitsbyId(id).subscribe(function (data) {
            console.log(data);
            _this.userprofiledata = data;
            _this.viewProfile = data;
            _this.viewProfile.aboutMe = data.aboutMe;
            _this.viewProfile.campus = data.campus;
            _this.viewProfile.booksIRecommend = data.booksIRecommend;
            _this.viewProfile.recommendationsReceived = data.recommendationsReceived;
            _this.allcir = data.coursesIRecommend;
            // this.allcir.forEach(element => {
            // 	element.course.imageURL = element.courseImageURL;
            // 	element.course.courseId = element.courseId;
            // });
            // console.log('hello');
            // console.log(this.allcir);
            _this.viewProfile.degreeCourse = data.degreeCourse;
            _this.viewProfile.eduIns = data.eduIns;
            _this.viewProfile.city = data.city;
            _this.viewProfile.countryId = data.countryId;
            _this.viewProfile.country = data.country;
            //this.viewProfile.isUserSecondaryDataCapturedForUser = (data.isUserSecondaryDataCapturedForUser == 'F') ? null : 'T';
            _this.viewProfile.isUserSignedInViaGoogle = data.isUserSignedInViaGoogle;
            _this.viewProfile.firstName = data.firstName;
            _this.viewProfile.lastName = data.lastName;
            _this.viewProfile.profilepicName = data.profilepicName;
            _this.viewProfile.middleName = data.middleName;
            _this.viewProfile.myInterests = data.myInterests;
            _this.viewProfile.noOfAlumniCOnnections = data.noOfAlumniCOnnections;
            _this.viewProfile.noOfProfessorConnections = data.noOfProfessorConnections;
            _this.viewProfile.noOfStudentConnections = data.noOfStudentConnections;
            _this.viewProfile.pastEducations = data.pastEducations;
            _this.viewProfile.projectResearchWorkExp = data.projectResearchWorkExp;
            _this.allskills = data.userSkillsets;
            console.log(_this.allskills);
            if (_this.allskills != null) {
                _this.allskills.forEach(function (val, ind, arr) {
                    _this.skillArr.skillName = val.userSkillSetName;
                    _this.skillArr.skillId = val.skillSetId;
                    _this.usergetSkills.push(_this.skillArr);
                    _this.skillArr = {};
                });
                console.log(_this.usergetSkills);
            }
            _this.viewProfile.subject = data.subject;
            _this.viewProfile.userDetailsId = data.userDetailsId;
            _this.viewProfile.userType = data.userType;
            _this.viewProfile.invitationAction = data.invitationAction;
            _this.viewProfile.ratingAction = data.ratingAction;
            _this.viewProfile.recommendationAction = data.recommendationAction;
            _this.viewProfile.noOfRatingStars = data.noOfRatingStars;
            _this.myRating = Array(data.noOfRatingStars);
            _this.userReqCourse.requestTo.userDetailsId = data.userDetailsId;
            _this.userReqCourse.requestFrom.userDetailsId = _this.user.userDetailsId;
            _this.reqRcmd.requestTo.userDetailsId = data.userDetailsId;
            _this.reqRcmd.requestFrom.userDetailsId = _this.user.userDetailsId;
            _this.rating.responseTo.userDetailsId = data.userDetailsId;
            _this.rating.responseFrom.userDetailsId = _this.user.userDetailsId;
            _this.calendarMeetingUrl = process.env.HOST_URL + 'meeting/' + data.publicCalendarProfileIdentifier;
            _this.showSpinner = false;
        }, function (error) {
            _this.handleError(error);
        });
        this.subscriptions.push(s9);
        var s10 = this.dashboardService.profileVisitsCoursebyMeId(id).subscribe(function (data) {
            _this.coursebyMe = data;
        }, function (error) {
            _this.handleError(error);
        });
        this.subscriptions.push(s10);
    };
    ProfileComponent.prototype.updateUser = function (e) {
        var _this = this;
        if (e) {
            var userSubscription = this.dashboardService.viewProfile().subscribe(function (res) {
                _this.viewProfile = res;
                console.log(res);
                _this.allcir = res.coursesIRecommend;
                _this.myRating = Array(res.noOfRatingStars);
                console.log('myRating');
                console.log(_this.myRating);
                _this.openStep2Popup = false;
            }, function (error) {
                _this.handleError(error);
                _this.openStep2Popup = false;
            });
            this.subscriptions.push(userSubscription);
        }
        else {
            this.openStep2Popup = false;
        }
    };
    ProfileComponent.prototype.convertMonth = function (mon) {
        var month = '01';
        switch (mon) {
            case 'January':
                month = '01';
                break;
            case 'February':
                month = '02';
                break;
            case 'March':
                month = '03';
                break;
            case 'April':
                month = '04';
                break;
            case 'May':
                month = '05';
                break;
            case 'June':
                month = '06';
                break;
            case 'July':
                month = '07';
                break;
            case 'August':
                month = '08';
                break;
            case 'September':
                month = '09';
                break;
            case 'October':
                month = '10';
                break;
            case 'November':
                month = '11';
                break;
            case 'December':
                month = '12';
                break;
        }
        return month;
    };
    ProfileComponent.prototype.closeErrorPopup = function () {
        console.log("After closing Error Popup");
        this.showSpinner = false;
        this.showOnlyOverlay = false;
        this.showErrorModalDialog = false;
        this.showErrorMessages = [];
    };
    ProfileComponent.prototype.handleError = function (error) {
        this.showSpinner = false;
        console.log("The error inside the Error Handler==>" + error);
        var url = error.url;
        console.log("The URL of the error==>" + error.url);
        if (url == undefined) {
            return;
        }
        console.log("Throwing the error now. Shall call the errorHandlerService throwError method");
        this.errorHandlerService.throwError(error);
    };
    ProfileComponent.prototype.ngOnDestroy = function () {
        this.subscriptions.forEach(function (element) {
            element.unsubscribe();
        });
    };
    return ProfileComponent;
}());
export { ProfileComponent };
//# sourceMappingURL=profile.component.js.map